



























































import { Mixins, Component, Emit } from 'vue-property-decorator';
import { AxPage } from '@/mixins';
import { AxStorage } from '@/storage';

interface DevList {
  title: string;
  items: DevItem[];
}

interface DevItem {
  name: string;
  components: DevComponent[];
  etc?: string;
}

interface DevComponent {
  component: string;
  properties: { [name: string]: string | boolean | object };
  value: string;
}

@Component
export default class extends Mixins(AxPage) {
  devList: DevList[] = [
    {
      title: 'AxButton',
      items: [
        {
          name: 'general',
          components: [
            {
              component: 'ax-button',
              value: '텍스트',
              properties: {
                color: 'orange',
              },
            },
            {
              component: 'ax-button',
              value: '텍스트',
              properties: {
                color: 'orange',
                disabled: true,
              },
            },
          ],
          etc: '',
        },
        {
          name: 'general + icon',
          components: [
            {
              component: 'ax-button',
              value: '업로드',
              properties: {
                color: 'orange',
                icon: 'mdi-image-plus',
              },
            },
            {
              component: 'ax-button',
              value: '업로드',
              properties: {
                color: 'orange',
                icon: 'mdi-image-plus',
                disabled: true,
              },
            },
          ],
          etc: '',
        },
        {
          name: 'big',
          components: [
            {
              component: 'ax-button',
              value: '저장',
              properties: {
                color: 'rgb(86, 171, 194)',
                big: true,
              },
            },
            {
              component: 'ax-button',
              value: '삭제',
              properties: {
                color: 'rgb(248, 100, 90)',
                big: true,
              },
            },
            {
              component: 'ax-button',
              value: '닫기',
              properties: {
                color: 'rgb(0, 0, 0, 0.3)',
                big: true,
              },
            },
            {
              component: 'ax-button',
              value: '닫기',
              properties: {
                color: 'rgb(0, 0, 0, 0.3)',
                big: true,
                disabled: true,
              },
            },
          ],
          etc: '',
        },
        {
          name: 'extra',
          components: [
            {
              component: 'ax-button',
              value: '출입문 그룹 추가',
              properties: {
                color: 'rgb(86, 171, 194)',
                icon: 'mdi-plus',
                extra: true,
              },
            },
            {
              component: 'ax-button',
              value: '출입문 그룹 추가',
              properties: {
                color: 'rgb(86, 171, 194)',
                icon: 'mdi-plus',
                extra: true,
                disabled: true,
              },
            },
          ],
          etc: '',
        },
      ],
    },
    {
      title: 'AxDockButton',
      items: [
        {
          name: 'panel',
          components: [
            {
              component: 'ax-dock-button',
              value: '',
              properties: {},
            },
            {
              component: 'ax-dock-button',
              value: '',
              properties: {
                disabled: true,
              },
            },
          ],
        },
      ],
    },
    {
      title: 'Selection Control',
      items: [
        {
          name: 'AxSelectBox',
          components: [
            {
              component: 'ax-select-box',
              value: '',
              properties: {
                value: 'value',
                items: [
                  { text: 'text', value: 'value' },
                  { text: 'text1', value: 'value1' },
                  { text: 'text2', value: 'value2' },
                  { text: 'text3', value: 'value3' },
                  { text: 'text4', value: 'value4' },
                  { text: 'text5', value: 'value5' },
                  { text: 'text6', value: 'value6' },
                  { text: 'text7', value: 'value7' },
                  { text: 'text8', value: 'value8' },
                  { text: 'text9', value: 'value9' },
                  { text: 'texta', value: 'valuea' },
                  { text: 'textb', value: 'valueb' },
                  { text: 'textc', value: 'valuec', disabled: true },
                  { text: 'textd', value: 'valued', disabled: true },
                  { text: 'texte', value: 'valuee' },
                  { text: 'textf', value: 'valuef' },
                  { text: 'textg', value: 'valueg' },
                  { text: 'texth', value: 'valueh', disabled: true },
                  { text: 'texti', value: 'valuei' },
                  { text: 'textj', value: 'valuej' },
                  { text: 'textk', value: 'valuek' },
                ],
              },
            },
            {
              component: 'ax-select-box',
              value: '',
              properties: {
                disabled: true,
                value: 'valuea',
                items: [
                  { text: 'text', value: 'value' },
                  { text: 'text1', value: 'value1' },
                  { text: 'text2', value: 'value2' },
                  { text: 'text3', value: 'value3' },
                  { text: 'text4', value: 'value4' },
                  { text: 'text5', value: 'value5' },
                  { text: 'text6', value: 'value6' },
                  { text: 'text7', value: 'value7' },
                  { text: 'text8', value: 'value8' },
                  { text: 'text9', value: 'value9' },
                  { text: 'texta', value: 'valuea' },
                  { text: 'textb', value: 'valueb' },
                  { text: 'textc', value: 'valuec' },
                  { text: 'textd', value: 'valued' },
                  { text: 'texte', value: 'valuee' },
                  { text: 'textf', value: 'valuef' },
                  { text: 'textg', value: 'valueg' },
                  { text: 'texth', value: 'valueh' },
                  { text: 'texti', value: 'valuei' },
                  { text: 'textj', value: 'valuej' },
                  { text: 'textk', value: 'valuek' },
                ],
              },
            },
          ],
        },
        {
          name: 'AxCheckBox',
          components: [
            {
              component: 'ax-check-box',
              value: '',
              properties: {
                label: '체크됨',
                value: true,
              },
            },
            {
              component: 'ax-check-box',
              value: '',
              properties: {
                label: '체크 해제',
              },
            },
            {
              component: 'ax-check-box',
              value: '',
              properties: {
                label: '비활성화',
                disabled: true,
              },
            },
          ],
        },
        {
          name: 'AxSwitchButton',
          components: [
            {
              component: 'ax-switch-button',
              value: '',
              properties: {
                label: '체크됨',
                value: true,
              },
            },
            {
              component: 'ax-switch-button',
              value: '',
              properties: {
                label: '체크 해제',
              },
            },
            {
              component: 'ax-switch-button',
              value: '',
              properties: {
                label: '비활성화',
                disabled: true,
              },
            },
          ],
        },
        {
          name: 'AxRadioButton',
          components: [
            {
              component: 'ax-radio-button',
              value: '',
              properties: {
                label: '일반',
              },
            },
            {
              component: 'ax-radio-button',
              value: '',
              properties: {
                label: '비활성화',
                disabled: true,
              },
            },
          ],
        },
      ],
    },
    {
      title: 'AxTextBox',
      items: [
        {
          name: 'general',
          components: [
            {
              component: 'ax-text-box',
              value: '',
              properties: {
                value: '텍스트입니다',
              },
            },
            {
              component: 'ax-text-box',
              value: '',
              properties: {
                value: '비활성화된 텍스트',
                disabled: true,
              },
            },
          ],
        },
        {
          name: 'outlined',
          components: [
            {
              component: 'ax-text-box',
              value: '',
              properties: {
                value: '텍스트입니다',
                outlined: true,
              },
            },
            {
              component: 'ax-text-box',
              value: '',
              properties: {
                value: '비활성화된 텍스트',
                disabled: true,
                outlined: true,
              },
            },
          ],
        },
      ],
    },
    {
      title: 'AxTabPanel',
      items: [
        {
          name: 'general',
          components: [
            {
              component: 'ax-tab-panel',
              value: '',
              properties: {
                value: ['탭1', '탭2'],
              },
            },
          ],
        },
        {
          name: 'disabled',
          components: [
            {
              component: 'ax-tab-panel',
              value: '',
              properties: {
                value: ['탭1', '탭2'],
                disabled: true,
              },
            },
          ],
        },
      ],
    },
  ];

  @Emit()
  scroll(event: HTMLElementEvent<HTMLDivElement>) {
    this.scrollTop = event.target.scrollTop;
  }

  get scrollTop() {
    return AxStorage.axDevScroll;
  }

  set scrollTop(value: number) {
    AxStorage.axDevScroll = value;
  }
}
